var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[!_vm.props.row.model && 'muted']},[_vm._v(" "+_vm._s(_vm.props.row.model ? _vm.props.formattedRow[_vm.props.column.field] : _vm.$t('misc.no_data'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }